import { API } from "../api/axios";
const END_POINT = "/articles";
const END_POINT_ARTICLE ="/article"

class ArticlesService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    get(id){
        return API.get(`${END_POINT_ARTICLE}/${id}`)
    }
    delete(id) {
        return API.delete(`${END_POINT_ARTICLE}/${id}`);
    }
    create(data) {
        return API.post(END_POINT_ARTICLE, data);
    }
    update(id, data) {
        return API.post(`${END_POINT_ARTICLE}/${id}`, data);
    }
}

export default new ArticlesService();
